import { http } from '../../../../api/http';
import type { DevolucionInternaReport } from '../types';

export const devolucionInternaService = {
  async getReport(): Promise<DevolucionInternaReport> {
    const response = await http.get('/produccion/Parte/devoluciones-internas');
    return response.data;
  },
};
